import React, { useRef } from 'react'

const ComingSoon = ({ comingSoon, setComingSoon }) => {

    const ModalRef = useRef()


    const closeModal = (e) => {
        if (ModalRef.current === e.target) {
            setComingSoon(!comingSoon)
        }
    }

    return (
        <>
            {comingSoon && (
                <div onClick={closeModal} ref={ModalRef} className='fixed flex sa:items-center items-end justify-center z-50  bg-black bg-opacity-30 inset-0'>
                    <div className='sm:w-[70%] sa:mx-5 lg:w-[45%] 2xl:w-[26.5%] text-[20px] w-full bg-white h-[30vh] sa:h-auto sa:rounded-[20px] flex flex-col items-center justify-center p-6'>
                        <p className='text-center text-orange-500'>COMING SOON</p>
                        <p className='text-center text-black'>This feature is coming very soon. Stay tuned</p>
                        <button
                            className='p-3 rounded-lg bg-[#491597] sa:w-[20%] w-full mx-auto mt-5 text-[#ffffff] py-[10px] px-4 text-[14px]'
                            onClick={() => {
                                setComingSoon(!comingSoon)
                            }}
                        >
                            Ok
                        </button>
                    </div>
                </div >
            )}
        </>
    )
}

export default ComingSoon